<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h3 class="text-h6">Datos de la Empresa en Encabezado</h3>
      <v-btn
        color="blue"
        outlined
        small
        @click="$emit('recargar-datos')"
      >
        <v-icon small left>mdi-refresh</v-icon>
        Recargar desde BD
      </v-btn>
    </div>
    
    <v-alert type="info" text dense class="mb-4">
      Configure qué datos de su empresa mostrar en el encabezado del remito (junto al logo).
      Use el botón "Recargar desde BD" para obtener los datos actuales de la base de datos.
    </v-alert>

    <v-card>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="80">Visible</th>
                <th>Campo</th>
                <th>Valor</th>
                <th width="150">Formato</th>
              </tr>
            </thead>
            <tbody>
              <!-- Razón Social -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.razonSocial.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Razón Social</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.razonSocial.valor"
                    dense
                    hide-details
                    placeholder="Ej: MURESCO"
                    :disabled="!datosInternos.razonSocial.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.razonSocial.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.razonSocial.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Dirección -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.direccion.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Dirección</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.direccion.valor"
                    dense
                    hide-details
                    placeholder="Ej: NORBERTO LÓPEZ 3600 (1642)"
                    :disabled="!datosInternos.direccion.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.direccion.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.direccion.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Localidad -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.localidad.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Localidad</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.localidad.valor"
                    dense
                    hide-details
                    placeholder="Ej: El Jagüel - Bs. As. - Argentina"
                    :disabled="!datosInternos.localidad.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.localidad.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.localidad.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Teléfono -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.telefono.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Teléfono</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.telefono.valor"
                    dense
                    hide-details
                    placeholder="Ej: Tel: 4290-0000"
                    :disabled="!datosInternos.telefono.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.telefono.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.telefono.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Sitio Web -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.web.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Sitio Web</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.web.valor"
                    dense
                    hide-details
                    placeholder="Ej: www.muresco.com"
                    :disabled="!datosInternos.web.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.web.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.web.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- CUIT -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.cuit.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>CUIT</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.cuit.valor"
                    dense
                    hide-details
                    placeholder="Ej: CUIT: 30-62262008-6"
                    :disabled="!datosInternos.cuit.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.cuit.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.cuit.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Inicio de Actividades -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.inicioActividades.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Inicio de Actividades</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.inicioActividades.valor"
                    dense
                    hide-details
                    placeholder="Ej: INICIO DE ACTIVIDADES: 09-02-1972"
                    :disabled="!datosInternos.inicioActividades.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.inicioActividades.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.inicioActividades.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Ingresos Brutos -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.ingresosBrutos.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Ingresos Brutos</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.ingresosBrutos.valor"
                    dense
                    hide-details
                    placeholder="Ej: IIBB: 901-0584468-9"
                    :disabled="!datosInternos.ingresosBrutos.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.ingresosBrutos.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.ingresosBrutos.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>

              <!-- Email -->
              <tr>
                <td>
                  <v-checkbox
                    v-model="datosInternos.email.visible"
                    hide-details
                    @change="emitirCambios"
                  ></v-checkbox>
                </td>
                <td><strong>Email</strong></td>
                <td>
                  <v-text-field
                    v-model="datosInternos.email.valor"
                    dense
                    hide-details
                    placeholder="Ej: info@empresa.com"
                    :disabled="!datosInternos.email.visible"
                    @input="emitirCambios"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="datosInternos.email.formato"
                    :items="formatosTexto"
                    dense
                    hide-details
                    :disabled="!datosInternos.email.visible"
                    @change="emitirCambios"
                  ></v-select>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-divider class="my-4"></v-divider>

        <!-- Configuración de estilo del encabezado -->
        <h4 class="subtitle-1 mb-3">Estilo del Encabezado</h4>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="datosInternos.estiloEncabezado.alineacion"
              :items="alineaciones"
              label="Alineación del texto"
              outlined
              dense
              @change="emitirCambios"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="datosInternos.estiloEncabezado.tamanoFuenteRazonSocial"
              label="Tamaño Razón Social"
              outlined
              dense
              placeholder="16px"
              hint="Tamaño del nombre de la empresa"
              persistent-hint
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="datosInternos.estiloEncabezado.tamanoFuente"
              label="Tamaño resto de campos"
              outlined
              dense
              placeholder="12px"
              hint="Tamaño de dirección, teléfono, etc."
              persistent-hint
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="datosInternos.estiloEncabezado.peso"
              :items="pesosFuente"
              label="Peso de fuente"
              outlined
              dense
              @change="emitirCambios"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DatosEmpresaEditor',
  
  props: {
    datosEmpresa: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      datosInternos: {
        razonSocial: { visible: true, valor: '', formato: 'normal' },
        direccion: { visible: true, valor: '', formato: 'normal' },
        localidad: { visible: true, valor: '', formato: 'normal' },
        telefono: { visible: false, valor: '', formato: 'normal' },
        web: { visible: false, valor: '', formato: 'normal' },
        cuit: { visible: true, valor: '', formato: 'normal' },
        inicioActividades: { visible: false, valor: '', formato: 'normal' },
        ingresosBrutos: { visible: false, valor: '', formato: 'normal' },
        email: { visible: false, valor: '', formato: 'normal' },
        estiloEncabezado: {
          alineacion: 'left',
          tamanoFuente: '10px',
          tamanoFuenteRazonSocial: '16px',
          peso: 'normal'
        }
      },
      formatosTexto: [
        { text: 'Normal', value: 'normal' },
        { text: 'Negrita', value: 'bold' },
        { text: 'Mayúsculas', value: 'uppercase' },
        { text: 'Minúsculas', value: 'lowercase' }
      ],
      alineaciones: [
        { text: 'Izquierda', value: 'left' },
        { text: 'Centro', value: 'center' },
        { text: 'Derecha', value: 'right' }
      ],
      pesosFuente: [
        { text: 'Normal', value: 'normal' },
        { text: 'Negrita', value: 'bold' },
        { text: 'Extra Negrita', value: 'bolder' }
      ]
    }
  },

  watch: {
    datosEmpresa: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.datosInternos = JSON.parse(JSON.stringify(newVal))
        }
      }
    }
  },

  methods: {
    emitirCambios() {
      this.$emit('update', this.datosInternos)
    }
  }
}
</script>

<style scoped>
.v-data-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.theme--dark .v-data-table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.02);
}
</style>
